import { ComplainDetailView } from "@/components/dashboard/shared/pages/ComplaintsPage"
import { useAuthStore } from "@/store/auth.store"
import { useNavigate } from "@tanstack/react-router"

export function ComplaintDetailsPage({ complaintId }: { complaintId: string }) {
  const currentUser = useAuthStore((s) => s.user)
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate({ to: "/complaints" })
  }

  return (
    <ComplainDetailView
      id={complaintId}
      onBack={handleGoBack}
      currentUser={currentUser}
      isAdmin={true}
    />
  )
}
